'use strict';

let mostPopularCategories = require('../components/mostPopularCategories');

/**
 * @param {JQuery} $message
 */
function initMessage($message) {
	if (!$message.length || $message.find('.lvz-search-no-results__popular').length) {
		return;
	}

	mostPopularCategories.loadIntoSearchEmptyMessage($message);
}

function initAll() {
	$('.lvz-content-search-empty__message[data-most-popular-url]').each(function () {
		initMessage($(this));
	});
}

module.exports = function initSearchNoResultsMostPopular() {
	initAll();

	$(document).on('ajaxComplete', function (event, xhr, settings) {
		if (settings.url && settings.url.indexOf('Search-Content') !== -1) {
			initAll();
		}
	});
};
